export enum EventKey {
  // fired if an existing language is changed via the selector
  LANGUAGE_CHANGE = 'change-language',
  // fired once the initial language has been loaded from local storage or the user settings
  INITIAL_LANGUAGE = 'initial-language',
  // fired if the app canvas is clicked, to close flyouts
  MAIN_CANVAS_CLICK = 'main-canvas-click',
}
